import CloseIcon from "@mui/icons-material/Close";
import { Box, CircularProgress, Dialog, DialogTitle, IconButton } from "@mui/material";
import { lazy, Suspense } from "react";
import { Assignment } from "../../api";
import { useGlobalState } from "../globalState";

const RoleExtractionWizard = lazy(() => import("./RoleExtractionWizard"));

const AssignmentAddDialog = ({
	open,
	onClose,
	onSave,
	id = "assignment-add-dialog",
	initialDescription,
}: {
	open: boolean;
	onClose?: () => void;
	onSave?: (data: Assignment) => Promise<Assignment>;
	id?: string;
	initialDescription?: string;
}) => {
	const { users, loading, currentUser } = useGlobalState();
	const handleClose = () => {
		if (!window.confirm("Discard this role? Any unsaved changes will be lost."))
			return;
		onClose?.();
	};

	return (
		<Dialog
			id={`${id}-dialog`}
			data-component="add-role-dialog"
			onClose={(_event, reason) => {
				if (reason === "backdropClick" || reason === "escapeKeyDown") return;
				handleClose();
			}}
			open={open}
			slotProps={{
				paper: {
					sx: { minWidth: 1200, minHeight: 500 },
				},
			}}
		>
			<DialogTitle
				id={`${id}-dialog-title`}
				data-component="add-role-title"
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				Add a new role
				<IconButton
					data-component="add-role-close-button"
					onClick={handleClose}
					aria-label="Close"
					size="small"
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			{open &&
				(!loading ? (
					<Box
						id={`${id}-dialog-content`}
						data-component="add-role-content"
						m={1}
					>
						<Suspense
							fallback={
								<CircularProgress data-component="wizard-loading" />
							}
						>
							<RoleExtractionWizard
								users={users}
								initialAssignment={
									{
										users: currentUser ? [currentUser.id] : [],
									} as Assignment
								}
								onSave={onSave}
								id={`${id}-wizard`}
								initialDescription={initialDescription}
								isStaff={
									!!(
										currentUser?.is_staff ||
										currentUser?.is_superuser
									)
								}
							/>
						</Suspense>
					</Box>
				) : (
					<CircularProgress
						id={`${id}-dialog-loading`}
						data-component="dialog-loading"
					/>
				))}
		</Dialog>
	);
};

export default AssignmentAddDialog;
